import React, {Component} from 'react';

class NoMatch extends Component {
  render() {
    return (
      <h1>Sorry what where you looking for?</h1>
    );
  }
}

export default NoMatch;



// WEBPACK FOOTER //
// ./src/views/NoMatch.js